import { render, staticRenderFns } from "./Position.vue?vue&type=template&id=f11a661c"
import script from "./Position.vue?vue&type=script&lang=ts"
export * from "./Position.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports